module.exports = "/assets/922700ae86317525e3bbf3aaf19d6b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4Q.png
// module id = 2173
// module chunks = 0